@use '../../../../../../base-variables.scss';

.Grid {
	display: grid;
	grid-gap: 16px;
	padding: 16px 0;
	grid-template-columns: auto auto;
	justify-items: center;
	div {
		// width: 100px;
		// height: 36px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		background-color: base-variables.$light-pastel-blue;
	}
	.Btn_Rounded {
		border-radius: 36px;
	}
	.Btn_Slightly_Rounded {
		border-radius: 6px;
	}
	.Frame {
		border: 2px solid base-variables.$light-pastel-blue;
		background-color: transparent;
		color: base-variables.$light-pastel-blue;
	}
}
